import { LOGIN_ACTION, LoginAction } from 'actions/authorization/loginAction'
import { LOGOUT_ACTION, LogoutAction } from 'actions/authorization/logoutAction'
import {
  CLEAR_PHOTO_RATING_SETTINGS,
  FETCH_PHOTO_RATING_SETTINGS,
  NORMALIZE_PHOTO_RATING_SETTINGS,
  PhotoRatingsSettingsTypes,
  RESET_INITIAL_PHOTO_RATING_FORM,
  SAVE_PHOTO_RATING_SETTINGS,
  SAVE_PHOTO_RATING_SETTINGS_UNAUTHORIZED,
  UPDATE_PHOTO_RATING_SETTINGS_FIELD,
} from 'actions/photoRating/photoRatingSettingsAction'
import { locationField } from 'common/constants'
import { isClientError } from 'functions/api/isClientError'
import { isServerError } from 'functions/api/isServerError'
import { defaultPromiseReducer } from 'reducers/defaultPromiseReducer'
import {
  initialState,
  PhotoRatingSettingsState,
} from 'reducers/rating/PhotoRatingSettingsState'

export const photoRatingSettingsReducer = (
  state = initialState,
  action: PhotoRatingsSettingsTypes | LoginAction | LogoutAction
): PhotoRatingSettingsState => {
  switch (action.type) {
    case FETCH_PHOTO_RATING_SETTINGS:
      return defaultPromiseReducer(
        state,
        action,
        () => ({
          settingsLoaded: false,
          photoRatingSettingsFetchingFailed: false,
        }),
        (result) => {
          if (result) {
            const form = {
              ageFrom: result.ageRange.from,
              ageTo: result.ageRange.to,
              heightFrom: result.heightRange!.from,
              heightTo: result.heightRange!.to,
              coordinates: result.coordinates,
              gender: result.gender!,
              country: result.locationName.country,
              region: result.locationName.region,
              city: result.locationName.city,
              metro: result.locationName.metro,
              countryName: result.locationName.countryName,
              regionName: result.locationName.regionName,
              cityName: result.locationName.cityName,
              metroName: result.locationName.metroName,
            }

            return {
              form: { ...form },
              settingsLoaded: true,
              defaultForm: { ...form },
              photoRatingSettingsFetchingFailed: false,
            }
          }

          return state
        },
        (result, state, error, errorStatus) => {
          if (isClientError(errorStatus)) {
            return {
              photoRatingSettingsFetchingServerError: false,
              settingsLoaded: false,
            }
          }
          if (isServerError(errorStatus)) {
            return {
              photoRatingSettingsFetchingServerError: true,
              settingsLoaded: false,
            }
          }
        }
      )

    case UPDATE_PHOTO_RATING_SETTINGS_FIELD:
      const { name, value, itemLocation } = action

      if (action.name === locationField) {
        return {
          ...state,
          form: {
            ...state.form,
            country: itemLocation!.country,
            countryName: itemLocation!.countryName,
            region: itemLocation!.region,
            regionName: itemLocation!.regionName,
            city: itemLocation!.city,
            cityName: itemLocation!.cityName,
            metro: itemLocation!.metro,
            metroName: itemLocation!.metroName,
            coordinates: false,
            currentLocationAutocomplete: itemLocation!,
          },
        }
      }

      return {
        ...state,
        form: {
          ...state.form,
          [name]: value,
        },
      }

    case SAVE_PHOTO_RATING_SETTINGS:
      return defaultPromiseReducer(
        state,
        action,
        () => ({
          formSaving: true,
        }),
        () => {
          return {
            defaultForm: {
              ...state.form,
            },
            formSaving: false,
          }
        },
        () => ({
          formSaving: false,
        })
      )

    case SAVE_PHOTO_RATING_SETTINGS_UNAUTHORIZED:
      return {
        ...state,
        defaultForm: { ...action.form },
        form: { ...action.form },
      }

    case NORMALIZE_PHOTO_RATING_SETTINGS:
      return defaultPromiseReducer(state, action, undefined, (result) => {
        if (result) {
          return {
            ...initialState,
          }
        }

        return state
      })

    case CLEAR_PHOTO_RATING_SETTINGS:
    case LOGIN_ACTION:
    case LOGOUT_ACTION:
      return { ...initialState }

    case RESET_INITIAL_PHOTO_RATING_FORM:
      return {
        ...state,
        form: {
          ...state.defaultForm,
        },
      }

    default:
      return state
  }
}
